import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',
    children: [
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'user', name: 'User', meta: { name: '用户管理' }, component: () => import('../views/manager/User') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/manager/Person') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '公告管理' }, component: () => import('../views/manager/Notice') },
      { path: 'logs', name: 'Logs', meta: { name: '系统日志' }, component: () => import('../views/manager/Logs') },
      { path: 'recipeManage', name: 'RecipeManage', meta: { name: '菜谱管理' }, component: () => import('../views/manager/RecipeManage') },
      { path: 'dietPlanManage', name: 'DietPlanManage', meta: { name: '推荐计划配置' }, component: () => import('../views/manager/DietPlanManage.vue') },
      { path: 'categoryManage', name: 'CategoryManage', meta: { name: '分类管理' }, component: () => import('../views/manager/CategoryManage') },
      { path: 'communityPostManage', name: 'CommunityPostManage', meta: { name: '社区动态管理' }, component: () => import('../views/manager/CommunityPostManage') },
      { path: 'banner', name: 'Banner', meta: { name: '轮播图管理' }, component: () => import('../views/manager/Banner') },
    ]
  },
  { path: '403', name: 'Auth', meta: { name: '无权限' }, component: () => import('../views/Auth.vue') },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: '404', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let user = JSON.parse(localStorage.getItem('honey-user') || '{}')
  // 管理员专属页面
  let adminPaths = ['/user', '/dietPlanManage', '/recipeManage', '/categoryManage', '/notice', '/logs', '/communityPostManage', '/banner']
  if (user.role !== '管理员' && adminPaths.includes(to.path)) {
    next('/home')
  } else {
    next()
  }
})

export default router
